(function () {
  const SELECTOR = '[data-featured-blog-hscroll]';

  function init(root) {
    if (!root) return;

    // Avoid double binding
    if (root.dataset.hscrollInit === '1') return;
    root.dataset.hscrollInit = '1';

    const scroller = root.querySelector('[data-hscroll]');
    const prev = root.querySelector('.featured-blog__hscroll-arrow--prev');
    const next = root.querySelector('.featured-blog__hscroll-arrow--next');

    if (!scroller || !prev || !next) return;

    // Ensure horizontal scroll is possible
    scroller.style.overflowX = 'auto';

    const amount = () => Math.max(200, Math.floor(scroller.clientWidth * 0.9));

    // ---- INITIAL STATE ----
    prev.classList.add('is-hidden');
    next.classList.remove('is-hidden');

    // ---- NEXT CLICK ----
    next.addEventListener('click', (e) => {
      e.preventDefault();
      scroller.scrollBy({ left: amount(), behavior: 'smooth' });

      // after movement, swap arrows
      setTimeout(() => {
        next.classList.add('is-hidden');
        prev.classList.remove('is-hidden');
        prev.classList.add('pop-in');
        setTimeout(() => prev.classList.remove('pop-in'), 400);
      }, 250);
    });

    // ---- PREV CLICK (wait until scroll settles, then swap back if at start) ----
    prev.addEventListener('click', (e) => {
      e.preventDefault();
      scroller.scrollBy({ left: -amount(), behavior: 'smooth' });

      let last = -1;
      let stableFrames = 0;

      const watch = () => {
        const x = scroller.scrollLeft;

        if (Math.abs(x - last) < 0.5) stableFrames += 1;
        else stableFrames = 0;

        last = x;

        // when scroll stops (a few stable frames) OR we hit start
        if (x <= 2 || stableFrames >= 6) {
          if (scroller.scrollLeft <= 2) {
            prev.classList.add('is-hidden');
            next.classList.remove('is-hidden');
             next.classList.add('pop-in');
            setTimeout(() => next.classList.remove('pop-in'), 400);
          }
          return;
        }

        requestAnimationFrame(watch);
      };

      requestAnimationFrame(watch);
    });
  }

  function boot(context) {
    const scope = context || document;
    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  // Normal load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  // Theme editor: section re-render
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
